import { Box, Container, Heading, Text } from "@chakra-ui/react";
import type { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";

// Import AG Grid modules and register them
import { AgChartsEnterpriseModule } from "ag-charts-enterprise";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import {
  AllEnterpriseModule,
  IntegratedChartsModule
} from "ag-grid-enterprise";

// Register AG Grid modules including charts
ModuleRegistry.registerModules([
  AllCommunityModule,
  AllEnterpriseModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule)
]);

function CampaignsTest() {
  // Simple test data
  const testData = [
    { id: 1, name: "Test Campaign 1", status: "active", budget: 5000 },
    { id: 2, name: "Test Campaign 2", status: "draft", budget: 3000 },
    { id: 3, name: "Test Campaign 3", status: "completed", budget: 7000 }
  ];

  // Simple column definitions
  const columnDefs: ColDef[] = useMemo(
    () => [
      { headerName: "ID", field: "id", width: 70 },
      { headerName: "Name", field: "name", flex: 1 },
      { headerName: "Status", field: "status", width: 120 },
      {
        headerName: "Budget",
        field: "budget",
        width: 120,
        valueFormatter: (params) => `$${params.value.toLocaleString()}`
      }
    ],
    []
  );

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true
    }),
    []
  );

  return (
    <Container maxW="6xl" py={8}>
      <Heading size="xl" mb={4} color="gray.800">
        AG Grid Test
      </Heading>
      <Text mb={6} color="gray.600">
        Data items: {testData.length}
      </Text>

      <Box bg="white" border="1px solid" borderColor="gray.200" rounded="md">
        <Box height="400px" width="100%">
          <AgGridReact
            rowData={testData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            onGridReady={(event) => {
              console.log("Test grid ready:", event.api);
              event.api.sizeColumnsToFit();
            }}
            cellSelection={true}
            rowSelection={{
              mode: "multiRow"
            }}
          />
        </Box>
      </Box>
    </Container>
  );
}

export default CampaignsTest;
